import {Color} from '@/Types/Enums/Color'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'

export const getRotationStatusColor = (rotation:Rotation):Color => {
	if(rotation.is_pending){
		return Color.Yellow
	}
	if(rotation.is_confirmed){
		return Color.Lime
	}
	if(rotation.is_completed){
		return Color.Teal
	}
	if(rotation.is_admissible){
		return Color.Green
	}
	return Color.Neutral
}